//THIS IS FOR THE LIST

export const listTransactions = `
  query MyQuery($filter: ModelTransactionFilterInput)  {
    listTransactions(filter: $filter) {
      nextToken
      items {
        full_name
        createdAt
        date_created
        date_released
        date_updated
        document_name
        updatedAt
        user_profile_id
        user_profile_photo
        transaction_status
        transaction_payment_status
        transaction_id
        released_by_id
        meeting_pass
        meeting_id
        id
        document_price
        user_location {
          latitude
          longitude
        }
        transaction_type
        lawyer_id
        registration_id
        scheduled_at
        scheduled_status
        document_title
        negotiation_status
        TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
       
       
      }
    }
  }
`;

export const listUserStatuses = `
  query MyQuery($filter: ModelUserStatusFilterInput)  {
    listUserStatuses(filter: $filter) {
      items {
        createdAt
        full_name
        id
        updatedAt
        user_location {
          latitude
          longitude
        }
        user_profile_id
        user_profile_photo
        user_status
        createdAt
        updatedAt
      }
    }
  }
`;
 

export const listTransactionLawyers = `
  query ListTransactionLawyers($filter: ModelTransactionLawyerFilterInput) {
    listTransactionLawyers(filter: $filter) {
      items {
        id
        transaction_id
        document_status
        user_profile_id
        lawyer_name
        document_price
        user_location
        {
          latitude
          longitude
        }
        created_by
        date_created
        date_updated
        updated_by
        transaction_status
        transaction_type
        user_profile_photo
      }
    }
  }
`;



export const listWitnessTransaction = `
  query MyQuery($filter: ModelWitnessTransactionFilterInput)  {
    listWitnessTransactions(filter: $filter) {
      nextToken
      items {
        contact_info
        createdAt
        created_by
        date_created
        id
        transaction_id
        updatedAt
      }
    }
  }
`;


export const listChatMessage = `
  query MyQuery($filter: ModelChatMessageFilterInput)  {
    listChatMessages(filter: $filter) {
      nextToken
      items {
        id
        chat_id
        transaction_id
        user_profile_id
        message
        date_created
        createdAt
        updatedAt
      }
    }
  }
`;


export const listChatNegotiation = `
  query MyQuery($filter: ModelChatNegotiationFilterInput)  {
    listChatNegotiations(filter: $filter) {
      nextToken
      items {
        id
        status
        lawyer_id
        transaction_id
        date_created
        createdAt
        updatedAt
      }
    }
  }
`;


export const chatMessagesByTransactionId = `
  query ChatMessagesByTransactionId($transaction_id: ID!) {
    chatMessagesByTransaction_id(transaction_id: $transaction_id) {
      items {
        id
        message
        transaction_id
        chat_id
      }
    }
  }
`;





export const listTransactionVideoConferences = `
  query MyQuery($filter: ModelTransactionVideoConferenceFilterInput)  {
    listTransactionVideoConferences(filter: $filter) {
      items {
        id
        transaction_id
        user_id
        user_tag
        createdAt
        updatedAt
      }
    }
  }
`;